import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import { FormattedWeight } from '../../../components/formatted-weight';
import { Multiple } from '../../../components/multiple-text-blurb-for-grid';
import { messages } from './messages';

import style from './weight.module.less';

const WeightColumn = ({ fulfillmentPlanId }) => {
  const labelConfiguration = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'labelConfiguration',
    }),
  );

  const { packages } = labelConfiguration ?? {};

  if (!packages?.length) {
    return null;
  }

  if (packages?.length > 1) {
    return <Multiple />;
  }

  const [{ weight }] = packages;

  return (
    <div className={style['weight-column']}>
      <FormattedWeight weight={weight} />
    </div>
  );
};

WeightColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const Weight = {
  getMessageDescriptor: () => messages.weight,
  id: 'weight',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (isExpanded && !isFirstRow) {
      return null;
    }
    return <WeightColumn fulfillmentPlanId={data.id} />;
  },
};
